import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Alert from "react-bootstrap/Alert";
import Router from "./Router.tsx";
import { setAlertVisibility, setAlert } from "../actions/alertActions";
import { setLanguage } from "../actions/languageActions";
import { getUserLanguage } from "./utils/Utils";
import * as translations from "../locale/";
import { Helmet } from 'react-helmet';
import "../styles/main.scss";
import ReactPixel from 'react-facebook-pixel';

const baseUrl = "/:locale([a-z]{2})?";
const languages = Object.keys(translations);

class App extends Component {
  componentDidMount() {
    const options = {
      autoConfig: true,
      debug: false,
    };
    ReactPixel.init(process.env.PIXEL_ID, null, options);
    ReactPixel.pageView();
  }
  
  render() {
    return (
      <>
        <BrowserRouter>
          <Switch>
            <Route path={baseUrl}>
              {({ match, location }) => {
                const params = match ? match.params : {};
                let {
                  locale = this.props.locale || getUserLanguage(),
                } = params;
                let { pathname } = location;

                // check if locale selected is supported by EVIO
                // if not, default to english and remove unsupported locale from pathname
                if (!languages.includes(locale)) {
                  locale = "en";
                  pathname = pathname.substring(3);
                }

                if (!pathname.includes(`/${locale}`)) {
                  if (pathname === "/")
                    return <Redirect to={`/${locale}/site-ceme`} />;
                  else return <Redirect to={`/${locale + pathname}`} />;
                }

                return <Router locale={locale} pathname={pathname} />;
              }}
            </Route>
          </Switch>
        </BrowserRouter>
        <Alert
          id="mainAlert"
          variant={this.props.alertVariant}
          show={this.props.alertVisible}
          onClose={() => this.props.setAlertVisibility(false)}
          dismissible
        >
          {typeof this.props.alertContent === "string" ? (
            this.props.alertContent
          ) : (
            <>
              <h6>{this.props.alertContent.title}</h6>
              <p>{this.props.alertContent.body}</p>
            </>
          )}
        </Alert>
        <Helmet>
          {/* Google Analytics */}
          <script>
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TQ8PPMQ3');
            `}
          </script>
        </Helmet>
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TQ8PPMQ3"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  languages: state.language.languages,
  translation: state.language.translation,
  alertVisible: state.alert.alertVisible,
  alertContent: state.alert.alertContent,
  alertVariant: state.alert.alertVariant,
  alertClose: state.alert.alertClose,
});

export default connect(mapStateToProps, {
  setAlert,
  setAlertVisibility,
  setLanguage,
})(App);
